import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

document.oncontextmenu = function (e) {
  if (e.button === 2 && !ReactIsInDevelomentMode()) {
    e.preventDefault();
    return false;
  }
}

document.addEventListener("keyup", function (e) {
  if (e.key === 44 && !ReactIsInDevelomentMode()) {
    stopPrntScr();
  }
});

function stopPrntScr() {
  var inpFld = document.createElement("input");
  inpFld.setAttribute("value", ".");
  inpFld.setAttribute("width", "0");
  inpFld.style.height = "0px";
  inpFld.style.width = "0px";
  inpFld.style.border = "0px";
  document.body.appendChild(inpFld);
  inpFld.select();
  document.execCommand("copy");
  inpFld.remove(inpFld);
}

function ReactIsInDevelomentMode() {
  return '_self' in React.createElement('div');
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
